import {
  ArrowRightOutlined,
  ReloadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Card, Spin } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAsyncEffect } from "use-async-effect";
import reportService from "../../../services/report.service";
import "../home/home.scss";

const UserCount: React.FC<any> = ({ autoReload }) => {
  const [loading, setLoading] = useState(true);
  const [userCount, setUserCount] = useState("");

  const getUserCount = async () => {
    setLoading(true);
    const res = await reportService.getUserCount();
    setUserCount(res.user_count);
    setLoading(false);
  };

  useAsyncEffect(async () => {
    getUserCount();
  }, []);

  return (
    <Card className="dashboard-card">
      <div className="widget-header">
        <span className="widget-title">Users</span>
        <div className="widget-actions">
          <Button
            onClick={getUserCount}
            icon={<ReloadOutlined />}
            size="small"
          />
          <Link to="/users">
            <Button icon={<ArrowRightOutlined />} size="small" />
          </Link>
        </div>
      </div>

      <div className="stat-card">
        {!loading ? (
          <>
            <UserOutlined className="stat-icon" />
            <div className="stat-value">{userCount}</div>
          </>
        ) : (
          <Spin />
        )}
      </div>
    </Card>
  );
};

export default UserCount;
